import script from "./MyEditBetsSlips.vue?vue&type=script&setup=true&lang=js"
export * from "./MyEditBetsSlips.vue?vue&type=script&setup=true&lang=js"

import "./MyEditBetsSlips.vue?vue&type=style&index=0&id=49360ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49360ebc"]])

export default __exports__